<div class="page">
  <h2>Sorry you do not have permission to view this page</h2>
  <p>If you believe you should have permission please contact your line manager.</p>
</div>
